import { render, staticRenderFns } from "./TableCustomRender.vue?vue&type=template&id=db5a3a38&"
import script from "./TableCustomRender.vue?vue&type=script&lang=js&"
export * from "./TableCustomRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports